import { Bookings } from '@/types/types'
import { amountToMajorUnit } from '@/utils/CurrencyFormatter'

type OfferAnalyticsItem = {
  item_id: number
  item_name: string
  affiliation: string
  index: number
  currency: string
  price: number
}

/**
 * Maps an offer to the GA4 analytics format used across the application
 */
export const mapOfferToAnalyticsItem = (
  offer: Bookings.SelectedOffer | Bookings.Offer,
  index: number,
  restaurantName: string = '',
  currency: string
): OfferAnalyticsItem => ({
  item_id: offer.id,
  item_name: offer.name,
  affiliation: restaurantName,
  index,
  currency,
  price: amountToMajorUnit(offer.charge_per_guests ?? 0, currency)
})
